import {Injectable} from '@angular/core';
import {environment} from "../../../../environments/environment";
import {Channel, Pusher} from "pusher-js";
import {VisbosService} from "../graphql/visbos.service";
import {Apollo} from "apollo-angular";
import {NgRedux, select} from "@angular-redux/store";
import {IAppState} from "../../../shared/redux-store";
import {SessionActions} from "../../../shared/actions";
import {Subject} from "rxjs/Subject";
import {BehaviorSubject} from "rxjs/BehaviorSubject";

declare const Pusher: any;

@Injectable()
export class PusherService extends VisbosService {

  @select(['session', 'loggedIn'])
  private loggedIn$;

  private privatePusher: Pusher;
  private publicPusher: Pusher;

  public userNotificationsChannel$: Subject<Channel> = new BehaviorSubject(null);
  public maintenanceChannel$: Subject<Channel> = new BehaviorSubject(null);


  constructor(apollo: Apollo, ngRedux: NgRedux<IAppState>, sessionActions: SessionActions) {
    super(apollo, ngRedux, sessionActions);

    this.initPublicPusher();

    this.loggedIn$.subscribe(loggedIn => {
      if (loggedIn) {
        this.authorizePusher(this.ngRedux.getState().session.token);
      } else {
        if (this.privatePusher) {
          this.privatePusher.disconnect();
          this.userNotificationsChannel$.next(null);
        }
      }
    });

  }

  private authorizePusher(token: string) {

    this.privatePusher = new Pusher(environment.pusher.key, {
      authEndpoint: environment.pusherAuthServer,
      auth: {
        headers: {
          'Authorization': "Bearer " + token
        }
      },
      cluster: 'eu',
      disableStats: true,
      encrypted: environment.pusher.encrypted,
      wsHost: environment.pusher.host,
      wsPort: environment.pusher.wsPort,
      wssPort: environment.pusher.wssPort,
      httpHost: environment.pusher.host,
      wsPath: environment.pusher.wsPath,
      //enabledTransports: ['ws', 'wss'],
      forceTLS: true
    });
    this.userNotificationsChannel$.next(this.privatePusher.subscribe('private-vb.maintenance'));

  }

  private initPublicPusher() {

    this.publicPusher = new Pusher(environment.pusher.key, {
      cluster: 'eu',
      disableStats: true,
      encrypted: environment.pusher.encrypted,
      wsHost: environment.pusher.host,
      wsPort: environment.pusher.wsPort,
      wssPort: environment.pusher.wssPort,
      httpHost: environment.pusher.host,
      wsPath: environment.pusher.wsPath,
      //enabledTransports: ['ws', 'wss'],
      forceTLS: true
    });
    this.maintenanceChannel$.next(this.publicPusher.subscribe('vb.maintenance'));

  }


}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/subscriptions/pusher.service.ts